export const variants = {
  danger: 'danger',
  info: 'info',
  success: 'success',
  warning: 'warning',
  seamless: 'seamless',
  neutral: 'neutral',
} as const

export const drawerSizes = {
  default: 'default',
  large: 'large',
} as const

export const triggerSizes = {
  default: 'default',
  small: 'small',
} as const

export const drawerDirections = {
  left: 'left',
  right: 'right',
}
